import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../../pagescss/QuestionSolution.css';
import AllQuestions from '../AllData/AllQuestions';
import Latex from 'react-latex';
import TopNavbar from '../home/TopNavbar';


// Lazy Image component with circle loader
const QuestionImage = ({ src, alt, className = "question-image" }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(false); // Reset loader when src changes
  }, [src]);
 
  return (
    <div className="image-wrapper">
      {!isLoaded && (
        <div className="loader-container">
          <div className="circle-loader" />
        </div>
      )}

      <img
        src={src}
        alt={alt}
        className={`${className} ${isLoaded? 'loaded' : ''}`}
        onLoad={() => setIsLoaded(true)}
        loading="lazy"
      />
    </div>
  );
};



const QuestionSolution = () => {
    const { id } = useParams();
    const questions = AllQuestions;
    const navigate = useNavigate();

    const questionData = questions.find(
        submission => submission._id.$oid === id
    );

    const isData = !!questionData;
    const question = isData ? questionData.question : null;
    const question_img = isData ? questionData.question_img : null;
    const ans = isData ? questionData.answer : null;
    const solution = isData ? questionData.solution : null;
    const solutionimg = isData ? questionData.solutionimg : null;
    const video = isData ? questionData.video : null;
    let answer = "";

    if (ans === "option1") { answer = isData ? questionData.option1 : null; }
    else if (ans === "option2") { answer = isData ? questionData.option2 : null; }
    else if (ans === "option3") { answer = isData ? questionData.option3 : null; }
    else if (ans === "option4") { answer = isData ? questionData.option4 : null; }




    // Function to render text with LaTeX
    const renderWithLatex = (text) => {
        if (!text) return null;

        // Check if text contains LaTeX patterns
        if (text.includes('$') || text.includes('\\')) {
            return <Latex>{text}</Latex>;
        }
        return text;
    };

    return (
        <div className="solution-container">

            <TopNavbar name="Question solution" />

        

            <div className="question-details">

                {question_img ? (
                    <>
                        <div className="question-image-container">
                            <img
                                src={`/questionsPhoto/${question_img}`}
                                alt="Question"
                                className="question-photo"
                            />
                        </div>
                    </>
                ) : (
                    <>
                        <div className='question-text'>
                            <h4>Q: {renderWithLatex(question)}</h4>
                        </div>
                    </>
                )}


            </div>

            <div className="answer-details">

                <p>Answer:  {renderWithLatex(answer)}</p>

            </div>

            <div className="solution-details">
                <p>Solution: </p>
                {solutionimg ? (
                    <img src={`/solutionsimg/${solutionimg}.png`} alt="Solution" className='question-photo-solutin' />
                ) : (
                    <p> {renderWithLatex(solution)}</p>

                )}


            </div>
        </div>

    );
};

export default QuestionSolution;